import {Col, Row} from 'antd';
import React from 'react';

import gaUserClickedSocialMediaShareButton from './ga/gaUserClickedSocialMediaShareButton';
import SocialButton from './SocialButton';

const SocialButtonsRow = ({shareText, clickFunc}) => (
  <Row gutter={8} type="flex" justify="space-around" align="middle">
    <Col xs={{span: 22}} sm={{span: 18}} lg={{span: 16}}>
      <div id="social-buttons-row">
        <h2 className="social-share-header">Share with your network!</h2>
        <SocialButton
          icon={<i className="fab fa-twitter" />}
          url="https://twitter.com/intent/tweet?text=Thinking%20about%20scheduling%20a%20meeting%3F%20Better%20check%20here%20first.&url=https%3A%2F%2Fshoulditbeameeting.com"
          type="twitter"
          clickFunc={() =>
            gaUserClickedSocialMediaShareButton(
              'User clicked Twitter share button',
            )}
        />
        <SocialButton
          icon={<i className="fab fa-linkedin-in" />}
          url="https://www.linkedin.com/shareArticle?url=https%3A%2F%2Fshoulditbeameeting.com&mini=true"
          type="linkedin"
          clickFunc={() =>
            gaUserClickedSocialMediaShareButton(
              'User clicked LinkedIn share button',
            )}
        />
        <SocialButton
          icon={<i className="fab fa-facebook-f" />}
          url="http://www.facebook.com/sharer.php?u=https%3A%2F%2Fwww.shoulditbeameeting.com"
          type="facebook"
          clickFunc={() =>
            gaUserClickedSocialMediaShareButton(
              'User clicked Facebook share button',
            )}
        />
        <SocialButton
          icon={<i className="far fa-envelope" />}
          url="mailto:?subject=Should%20It%20Be%20a%20Meeting%3F&body=https%3A%2F%2Fshoulditbeameeting.com%2F%23%2F"
          clickFunc={() =>
            gaUserClickedSocialMediaShareButton(
              'User clicked email share button',
            )}
        />
      </div>
    </Col>
  </Row>
);

export default SocialButtonsRow;



// WEBPACK FOOTER //
// ./src/SocialButtonsRow.js